import logo from './logo.svg';
import './App.css';
import Head from './component/Head';
import Country from './component/Country';

function App() {
  return (
    <div>
      <Head/>
      <br/>
      <Country/>
    </div>
  );
}

export default App;
